// SP
function isSmartPhone() : boolean {
    return document.body.clientWidth <= 768;
}

// userAgent
let userAgent = window.navigator.userAgent.toLowerCase();

// TOP - get window.innerHeight and set value to css '--vh'
if(isSmartPhone()) {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
}


// supportsWebP
const supportsWebP = (): Promise<boolean> => {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
        img.onload = img.onerror = () => {
            resolve(img.width > 0 && img.height > 0);
        }
    });
};
supportsWebP().then((support) => {
    document.documentElement.classList.add(support ? 'webp' : 'no-webp');
});


// MENU
const objMenu: HTMLElement = <HTMLElement>document.querySelector('.menu-toggle'),
    objNav: HTMLElement = <HTMLElement>document.querySelector('.nav');

if(objMenu) {
    objMenu.addEventListener("click", function () {
        toggleMenu()
    });
    objNav.addEventListener("click", function () {
        toggleMenu();
    });
    let toggleMenu = function() {
        objMenu.classList.toggle("active");
        objNav.classList.toggle("active");
        document.body.classList.toggle("noScroll");
    }
}

// Fade Up Animation
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        const ratio = entry.intersectionRatio;

        if (entry.isIntersecting && ratio > 0.5) {
            // 50%以上表示されたらis-visibleをつける
            entry.target.classList.add('is-visible');
        } else if (!entry.isIntersecting && ratio === 0) {
            // 完全に見えなくなったときだけis-visibleを外す
            entry.target.classList.remove('is-visible');
        }
    });
}, {
    threshold: [0, 0.5, 1.0]
});
document.querySelectorAll('.fade-up').forEach(el => {
    observer.observe(el);
});

// 郵便番号補完
const zipcodeInput = document.getElementById('zip') as HTMLInputElement;
const address1Input = document.getElementById('address') as HTMLInputElement;
if (zipcodeInput && address1Input) {
    // console.log('郵便番号の自動入力の処理ができます。');
    zipcodeInput.addEventListener('blur', function () {
        const zipcode = this.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
        if (zipcode.length === 7) { // Ensure the postal code is 7 digits
            fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipcode}`)
                .then(response => response.json())
                .then(data => {
                    if (data.results) {
                        const result = data.results[0];
                        address1Input.value = result.address1 + result.address2 + result.address3; // City and street
                    } else {
                        console.log('郵便番号が見つかりませんでした。', zipcode);
                    }
                })
                .catch(error => {
                    console.error('Error fetching postal code data:', error);
                    console.log('郵便番号検索中にエラーが発生しました。', zipcode);
                });
        } else {
            console.log('正しい7桁の郵便番号を入力してください。', zipcode);
        }
    });
}